var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loader-container", class: { full: _vm.fullPage } },
    [
      _c("div", { staticClass: "loader-group" }, [
        _vm.showAnimation
          ? _c("div", [
              _c("img", {
                staticClass: "loader-image",
                class: _vm.loaderClass,
                staticStyle: { "max-width": "50px" },
                attrs: { src: require("@/assets/img/logo_nedgia-icon.png") }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hexagon loader", class: _vm.loaderClass },
                [
                  _c("div", { staticClass: "ball ball_one" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ball ball_two" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ball ball_three" })
                ]
              ),
              _vm._v(" "),
              _c("svg", { staticClass: "svg-filter" }, [
                _c("defs", [
                  _c(
                    "filter",
                    { attrs: { id: "filter" } },
                    [
                      _c("feGaussianBlur", {
                        attrs: {
                          in: "SourceGraphic",
                          stdDeviation: "18",
                          result: "blur"
                        }
                      }),
                      _vm._v(" "),
                      _c("feColorMatrix", {
                        attrs: {
                          in: "blur",
                          mode: "matrix",
                          values:
                            "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10",
                          result: "filter"
                        }
                      }),
                      _vm._v(" "),
                      _c("feComposite", {
                        attrs: {
                          in: "SourceGraphic",
                          in2: "filter",
                          operator: "atop"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "text-center" }, [
          _vm._v("\n      " + _vm._s(_vm.msg) + "\n    ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Loader.vue?vue&type=template&id=360e3290&scoped=true&
// module id = null
// module chunks = 